import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { affinitiesRoutes } from 'app/siq-applications/modules/affinities/routes/affinities-routes';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(affinitiesRoutes)
  ],
  exports: [RouterModule]
})
export class AffinitiesRoutingModule { }
